"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var mealOrderApi = _interopRequireWildcard(require("@/api/mealOrderApi.js"));
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Tinymce: _index.default
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {},
      brandOption: []
    };
  },
  methods: {
    throttle: _throttle.default,
    openInit: function openInit(tagDetails) {
      this.pram = _objectSpread(_objectSpread({}, tagDetails), {}, {
        channel: Number(tagDetails.channel) || 1,
        priceAdjustType: tagDetails.priceAdjustType !== undefined ? Number(tagDetails.priceAdjustType) : 0,
        priceAdjustRatio: tagDetails.priceAdjustRatio !== undefined ? Number(tagDetails.priceAdjustRatio) : 0,
        maxGrossMarginEnabled: Number(tagDetails.maxGrossMarginEnabled) === 1 ? 1 : 0,
        maxGrossMargin: tagDetails.maxGrossMargin !== undefined && tagDetails.maxGrossMargin !== null ? Number(tagDetails.maxGrossMargin) : undefined
      });
      this.visible = true;
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        var submitData = _objectSpread({}, _this.pram);
        if (submitData.maxGrossMarginEnabled === 1) {
          submitData.maxGrossMargin = Number(Number(submitData.maxGrossMargin).toFixed(2));
        }
        _this.loading = true;
        mealOrderApi.updateMealShop(submitData).then(function (data) {
          _this.$message.success('操作成功');
          _this.loading = false;
          _this.visible = false;
          _this.$emit('doRefresh');
        }).catch(function () {
          _this.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    //上传图片
    modalPicTap: function modalPicTap(tit, dataIndex) {
      var _this2 = this;
      this.$modalUpload(function (img) {
        _this2.$set(_this2.pram, dataIndex, img[0].sattDir);
      }, tit, 'system');
    },
    removeImg: function removeImg(dataIndex) {
      this.$set(this.pram, dataIndex, '');
    },
    // 验证调价比例是否在 -100 到 100 之间
    validatePriceAdjustRatio: function validatePriceAdjustRatio(rule, value, callback) {
      var num = Number(value);
      if (isNaN(num)) {
        callback(new Error('请输入有效的数字'));
      } else if (num < -100 || num > 100) {
        callback(new Error('请输入 -100 到 100 之间的数'));
      } else {
        callback();
      }
    },
    validateMaxGrossMargin: function validateMaxGrossMargin(rule, value, callback) {
      if (this.pram.maxGrossMarginEnabled !== 1) {
        callback();
        return;
      }
      var num = Number(value);
      if (value === undefined || value === null || value === '' || Number.isNaN(num)) {
        callback(new Error('请输入最大毛利率'));
      } else if (num <= 0 || num > 100) {
        callback(new Error('最大毛利率必须大于0且小于等于100'));
      } else {
        callback();
      }
    }
  }
};